<template>
  <nuttrema-layout-content>
    <template slot="header">
      <persons-standard-header
        :meta="meta"
        :PersonDetails="PersonDetails">
        <template v-if="showEdit" slot="edit">
          <div class="content-header-item">
            <permissions-control-wrapper
              :required-general="$PERMISSIONS_GENERAL.SET_STATUS"
              :permissions="_get(PersonDetails, 'meta.permissions')">
              <edit-lock-button slot="allowed" :edit.sync="edit"></edit-lock-button>
              <edit-lock-button slot="not-allowed" :lock="true"></edit-lock-button>
            </permissions-control-wrapper>
          </div>
        </template>
      </persons-standard-header>
    </template>

    <template slot="central">
      <nuttrema-loader v-if="PersonDetails.fetching"></nuttrema-loader>
      <form-participant-status
         v-else
        :edit.sync="edit"
        :PersonDetails="PersonDetails"
        @submit="onSubmit"
        @sendActivationEmail="onSendActivationEmail">
      </form-participant-status>
    </template>
  </nuttrema-layout-content>
</template>

<script>
import { get } from 'lodash';
import { mapActions } from 'vuex';

import { PERSON_KEYS } from 'constants/types';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import PersonsStandardHeader from 'components/pages/professional/persons/participants/shared/blocks/cmpt-persons-standard-header';

import FormParticipantStatus from './form-participant-status';

export default {
  name: 'page-participant-status',
  mixins: [PageProps],
  props: {
    id: {
      required: false,
      default: null,
    },
    type: {
      required: false,
      default: PERSON_KEYS.participant,
    },
  },
  components: {
    FormParticipantStatus,
    PersonsStandardHeader,
    NuttremaLayoutContent,
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    PersonDetails() {
      return this.$store.getters.PersonDetails(this.id);
    },
    showEdit() {
      return get(this.PersonDetails, 'data.account_activated') || get(this.PersonDetails, 'data.offline_user');
    },
  },
  methods: {
    ...mapActions([
      'SetPersonStatus',
      'SendPersonAccountActivationToken',
    ]),
    onSubmit(payload) {
      this.SetPersonStatus({ id: this.id, type: this.type, payload }).then(() => {
        this.successNotification({ label: 'label.status' });
      }).catch(() => {
        this.errorNotification({ label: 'label.status' });
      });
    },
    onSendActivationEmail() {
      this.SendPersonAccountActivationToken({ id: this.id, type: this.type }).then(() => {
        this.successNotification({ message: 'message.successfully_send', label: 'label.activation_email' });
      }).catch(() => {
        this.errorNotification({ message: 'message.error_send', label: 'label.activation_email' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/status/page-participant-status.vue